import React from 'react';

const html = `
	<tbody> 
    <tr> 
     <td> 
      <table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:5px;padding-top:10px"> 
                  <div style="font-family:sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:14.399999999999999px;color:#555;line-height:1.2"> 
                    <p style="margin:0;font-size:12px;text-align:center;mso-line-height-alt:14.399999999999999px">&nbsp;</p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#494949"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:10px;padding-top:10px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:218.75px"> 
                    <a href="https://www.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/5f7ed578-1133-40e8-91aa-f6024022efda/webhotelier-primalres_white.png" style="display:block;height:auto;border:0;width:100%" width="218.75" alt="" title="" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-3" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#2463eb;background-image:url(https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/2526706c-b949-4581-9212-22a3864009b0/header_roompulse.png);background-position:top center;background-repeat:no-repeat;background-size:auto"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-size:auto;border-radius:1px;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <div class="spacer_block block-1" style="height:60px;line-height:60px;font-size:1px">
                  
              </div> 
              <table class="image_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:151.25px"> 
                    <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/ba4b9d34-d817-461f-8a53-86ac63e2d9cc/Workspace App.png" style="display:block;height:auto;border:0;width:100%" width="151.25" alt="" title="" height="auto"> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="image_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-top:15px;width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:302.5px"> 
                    <a href="https://www.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/eee9aded-e876-479a-b36f-53a758c3775e/Group 6451.png" style="display:block;height:auto;border:0;width:100%" width="302.5" alt="" title="" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-4" width="100%" border="0" cellpadding="15" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:14.399999999999999px;color:#fff;line-height:1.2"> 
                    <p style="margin:0;font-size:14px;text-align:left;mso-line-height-alt:14.399999999999999px;letter-spacing:3px">&nbsp;</p> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:16.8px;letter-spacing:3px"> <span style="word-break: break-word; font-size: 30px; color: #ffffff;"><strong><span style="word-break: break-word;">The new generation of<br>Rate Shopper replacing<br>"Competitors"</span></strong></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-4" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-size:auto"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-size:auto;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:10px;padding-top:25px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-family:Verdana,Geneva,sans-serif;font-size:12px;mso-line-height-alt:18px;color:#fff;line-height:1.5"> 
                    <p style="margin:0;font-size:20px;text-align:center;mso-line-height-alt:30px"> <span style="word-break: break-word; font-size: 20px;"><strong><span style="word-break: break-word; color: #3c4043;">Activate our group’s brand-new workspace app, starting today!</span></strong></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:25px;padding-left:60px;padding-right:60px;padding-top:10px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:18px;color:#4a4a4a;line-height:1.5"> 
                    <p style="margin:0;font-size:16px;text-align:center;mso-line-height-alt:24px"> <span style="word-break: break-word; color: #3a3a3a;"><span style="word-break: break-word; font-size: 16px;">With a modern design, advanced functionalities, and a seamless,<strong> free transition</strong>. A powerful tool designed to optimize your pricing strategy.</span></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-5" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:5px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:14.399999999999999px;color:#0132a3;line-height:1.2"> 
                    <p style="margin:0;font-size:12px;text-align:center;mso-line-height-alt:14.399999999999999px;letter-spacing:normal"><span style="word-break: break-word; font-size: 20px; color: #3a3a3a;"><strong>What Roompulse offers you:</strong></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-6" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#e1ebef;border-radius:20px 20px 0 0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:10px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:5px;padding-left:10px;padding-right:10px;padding-top:15px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:20px;text-align:center;mso-line-height-alt:30px;letter-spacing:normal"><span style="word-break: break-word; font-size: 20px;"><strong><span style="word-break: break-word; color: #3a3a3a;">Key features</span></strong></span></p> 
                    <p style="margin:0;font-size:20px;text-align:center;mso-line-height-alt:30px;letter-spacing:normal"> <span style="word-break: break-word; font-size: 20px;"><span style="word-break: break-word; color: #3a3a3a;">All features are available under</span></span></p> 
                    <p style="margin:0;font-size:20px;text-align:center;mso-line-height-alt:30px;letter-spacing:normal"><span style="word-break: break-word; font-size: 20px;"><span style="word-break: break-word; color: #3a3a3a;">your current annual subscription.</span></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-7" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#e1ebef;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-right:10px;padding-top:5px;width:100%;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/f0b48a7d-68f8-441d-b914-f026e9b696d4/mobile.png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="Image" title="Image" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px">A fresh, user-friendly interface now <strong>fully mobile-optimized</strong>.</p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
             <td class="column column-2" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/8aec66d7-e868-441b-99a0-d7acf5fd0cb7/mapping.png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="" title="" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"> <span style="word-break: break-word; color: #3a3a3a;"><strong>Room Mapping functionality<br></strong>Improved rate comparison by room type.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-8" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#e1ebef;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-right:10px;padding-top:5px;width:100%;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/1735c3a3-4872-49cc-addf-b97618c8b180/02_parity.png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="Image" title="Image" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Parity<br></strong>Compare the rates on your website with those on OTAs like Booking.com, Expedia, and more.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
             <td class="column column-2" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/bc67b64f-7a5a-4675-bd51-01836fa23575/extranet_1742569919084png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="" title="" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Chrome Extension<br> </strong>Instantly view competitor pricing while making updates in webhotelier, no need to switch tabs or open another app.<br></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-9" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#e1ebef;border-radius:0 0 20px 20px;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-right:10px;padding-top:5px;width:100%;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/fa760d4c-97f7-420f-9f5d-47afffb24bbf/rate.png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="Image" title="Image" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:18px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Rate Timeline<br></strong>Track how prices evolve over specific days or time periods.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
             <td class="column column-2" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:20px;padding-right:20px;padding-top:40px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-right:10px;padding-top:5px;width:100%;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:163.5px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/ad43c40d-910c-45cb-b5c0-183c97dc0f31/speed.png" style="display:block;height:auto;border:0;width:100%" width="163.5" alt="Image" title="Image" height="auto"></a> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:10px;padding-right:10px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:18px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Faster data updates <br></strong>Get real-time insights with faster data refresh for precise decision-making.<br></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-10" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;vertical-align:top"> 
              <div class="spacer_block block-1" style="height:10px;line-height:10px;font-size:1px">
                  
              </div></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-11" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:20px 20px 0 0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr class="reverse"> 
             <td class="column column-1 first" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-top:10px;vertical-align:top"> 
              <div class="border"> 
               <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad" style="padding-left:10px;padding-right:10px;padding-top:35px"> 
                   <div style="font-family:Verdana,sans-serif"> 
                    <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"> 
                     <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:16.8px;letter-spacing:normal"><span style="word-break: break-word; font-size: 20px; color: #3a3a3a;"><strong>Premium features</strong></span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
               <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div style="font-family:sans-serif"> 
                    <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:16.8px;color:#555;line-height:1.2"> 
                     <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:16.8px"><span style="word-break: break-word; color: #3972ec;"><em>- With extra fee -</em></span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-12" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr class="reverse"> 
             <td class="column column-1 first" width="33.333333333333336%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <div class="border"> 
               <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
                <tbody> 
                 <tr> 
                  <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                   <div class="alignment" align="center"> 
                    <div style="max-width:47px"> 
                     <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/32b3dd3b-96f6-4992-89fc-57c7a75290d5/Intelligent-alerts.png" style="display:block;height:auto;border:0;width:100%" width="47" alt="" title="" height="auto"> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
               <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div style="font-family:Verdana,sans-serif"> 
                    <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                     <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; font-size: 14px; color: #555555;"><span style="word-break: break-word; color: #3a3a3a;"><strong>Intelligent Alerts<br></strong>Receive price change notifications.</span><br></span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div> </td> 
             <td class="column column-2" width="33.333333333333336%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div style="max-width:47px"> 
                    <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/9dd98d6d-26c9-4594-be4c-85ed331e7cb8/Excel (1).png" style="display:block;height:auto;border:0;width:100%" width="47" alt="" title="" height="auto"> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Excel Export<br></strong>Analyze your data, easily and quickly.&nbsp;&nbsp;</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
             <td class="column column-3 last" width="33.333333333333336%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:5px;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <div class="border"> 
               <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
                <tbody> 
                 <tr> 
                  <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                   <div class="alignment" align="center"> 
                    <div style="max-width:47.083px"> 
                     <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/8d3baf95-a7e3-438b-a475-b1a5039c410e/Country-Rates (1).png" style="display:block;height:auto;border:0;width:100%" width="47.083" alt="" title="" height="auto"> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
               <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div style="font-family:Verdana,sans-serif"> 
                    <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                     <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Country Rates<br></strong>View pricing information by country.</span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-13" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr class="reverse"> 
             <td class="column column-1 first" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <div class="border"> 
               <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
                <tbody> 
                 <tr> 
                  <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                   <div class="alignment" align="center"> 
                    <div style="max-width:58.5px"> 
                     <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/9e038c9a-91fc-49d3-b23e-adb478c1c1eb/genius-1.png" style="display:block;height:auto;border:0;width:100%" width="58.5" alt="" title="" height="auto"> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
               <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div style="font-family:Verdana,sans-serif"> 
                    <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                     <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a;"><strong>Mobile &amp; Genius Rates<br></strong>Compare offers for members and mobile devices to find the best deals.</span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div></td> 
             <td class="column column-2 last" width="50%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-left:10px;padding-right:10px;padding-top:10px;vertical-align:top"> 
              <div class="border"> 
               <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
                <tbody> 
                 <tr> 
                  <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                   <div class="alignment" align="center"> 
                    <div style="max-width:58.5px"> 
                     <img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/b78870eb-c5df-4f49-8318-1f7e4c6cd4f3/compare.png" style="display:block;height:auto;border:0;width:100%" width="58.5" alt="" title="" height="auto"> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
               <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div style="font-family:sans-serif"> 
                    <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:18px;color:#555;line-height:1.5"> 
                     <p style="margin:0;font-size:12px;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; font-size: 14px; color: #3a3a3a;"><strong>Extra Providers<br></strong>Compare packages from Agoda and B2B platforms (e.g. Holiday Check).</span></p> 
                    </div> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-14" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr class="reverse"> 
             <td class="column column-1 first" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:30px;padding-top:15px;vertical-align:top"> 
              <div class="border"> 
               <table class="button_block block-1" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
                <tbody> 
                 <tr> 
                  <td class="pad"> 
                   <div class="alignment" align="center"> 
                    <a href="https://app.roompulse.io/sign-up" target="_blank" style="color:#353535;text-decoration:none;"> 
                     <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"  href="https://app.roompulse.io/sign-up"  style="height:51px;width:340px;v-text-anchor:middle;" arcsize="0%" fill="false">
<v:stroke dashstyle="ShortDot" weight="3px" color="#2463eb"/>
<w:anchorlock/>
<v:textbox inset="0px,0px,0px,0px">
<center dir="false" style="color:#353535;font-family:Verdana, sans-serif;font-size:14px">
<![endif]--> <span class="button" style="background-color: transparent; border-bottom: 3px dotted #2463eb; border-left: 3px dotted #2463eb; border-radius: 0px; border-right: 3px dotted #2463eb; border-top: 3px dotted #2463eb; color: #353535; display: inline-block; font-family: Verdana, Geneva, sans-serif; font-size: 14px; font-weight: 700; mso-border-alt: none; padding-bottom: 5px; padding-top: 5px; padding-left: 20px; padding-right: 20px; text-align: center; width: auto; word-break: keep-all; letter-spacing: normal;"><span style="word-break: break-word; line-height: 21px;"><strong><u>Click here</u></strong> to try the premium features <br>for free for 14 days.</span></span> 
                     <!--[if mso]></center></v:textbox></v:roundrect><![endif]--></a> 
                   </div></td> 
                 </tr> 
                </tbody> 
               </table> 
              </div></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-15" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#3972ec;border-radius:20px 20px 0 0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-top:10px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:15px;padding-left:50px;padding-right:50px;padding-top:25px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:14px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:21px;color:#555;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px;letter-spacing:normal"> <strong><span style="word-break: break-word; font-size: 20px; color: #ffffff;">Switching to Roompulse takes just one click!</span></strong></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-16" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#3972ec;border-radius:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-top:10px;vertical-align:top"> 
              <table class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="width:100%;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <div class="fullWidth" style="max-width:469px"> 
                    <a href="https://hotel.webhotelier.net/" target="_blank" style="outline:none" tabindex="-1"><img src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/20cd7425-664a-423f-9293-fdf47188445a/Dell_extranet (2).png" style="display:block;height:auto;border:0;width:100%" width="469" alt="" title="" height="auto"></a> 
                   </div> 
                  </div> </td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-left:60px;padding-right:30px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-family:Verdana,Geneva,sans-serif;font-size:12px;mso-line-height-alt:18px;color:#483a7e;line-height:1.5"> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #ffffff; font-size: 14px; background-color: transparent;">1. Log into webhotelier extranet.</span></p> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #ffffff; font-size: 14px;">2. Click on Roompulse.<br>3. Select the competitors you want to monitor.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-3" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:20px;padding-left:40px;padding-right:40px;padding-top:20px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-family:Verdana,Geneva,sans-serif;font-size:12px;mso-line-height-alt:18px;color:#483a7e;line-height:1.5"> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:30px"> <span style="word-break: break-word; font-size: 20px;"><span style="word-break: break-word; color: #ffffff;">You're all set!</span></span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-17" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#3972ec;border-radius:0 0 20px 20px;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-top:10px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:40px;padding-left:40px;padding-right:40px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-family:Verdana,Geneva,sans-serif;font-size:12px;mso-line-height-alt:18px;color:#483a7e;line-height:1.5"> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:21px"> <span style="word-break: break-word; color: #ffffff; font-size: 14px;">Explore the new features, make the most of the key functionalities, and discover the premium ones.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-18" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0 0 20px 20px;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:30px;padding-top:30px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="padding-bottom:10px;padding-left:10px;padding-right:10px"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-family:Verdana,Geneva,sans-serif;font-size:12px;mso-line-height-alt:18px;color:#483a7e;line-height:1.5"> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:30px"> <span style="word-break: break-word; color: #3a3a3a; font-size: 20px;"><strong><span style="word-break: break-word;">Need more information?</span></strong></span></p> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:21px"><span style="word-break: break-word; color: #3a3a3a; font-size: 14px;">Book an online appointment with the Roompulse support team<br>or call at +30 698 502 2646.</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="button_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div class="alignment" align="center"> 
                   <a href="https://calendly.com/dionisis-roompulse/competitors-switch" target="_blank" style="color:#ffffff;text-decoration:none;"> 
                    <!--[if mso]>
<v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"  href="https://calendly.com/dionisis-roompulse/competitors-switch"  style="height:38px;width:117px;v-text-anchor:middle;" arcsize="11%" fillcolor="#494949">
<v:stroke dashstyle="Solid" weight="0px" color="#494949"/>
<w:anchorlock/>
<v:textbox inset="0px,0px,0px,0px">
<center dir="false" style="color:#ffffff;font-family:Verdana, sans-serif;font-size:14px">
<![endif]--> <span class="button" style="background-color: #494949; border-bottom: 0px solid transparent; border-left: 0px solid transparent; border-radius: 4px; border-right: 0px solid transparent; border-top: 0px solid transparent; color: #ffffff; display: inline-block; font-family: Verdana, Geneva, sans-serif; font-size: 14px; font-weight: 700; mso-border-alt: none; padding-bottom: 5px; padding-top: 5px; padding-left: 20px; padding-right: 20px; text-align: center; width: auto; word-break: keep-all; letter-spacing: normal;"><span style="word-break: break-word; line-height: 28px;">Book now</span></span> 
                    <!--[if mso]></center></v:textbox></v:roundrect><![endif]--></a> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-19" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#494949"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;color:#333;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:30px;padding-top:30px;vertical-align:top"> 
              <table class="social_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
               <tbody> 
                <tr> 
                 <td class="pad" style="text-align:center;padding-right:0;padding-left:0"> 
                  <div class="alignment" align="center"> 
                   <table class="social-table" width="111px" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;display:inline-block"> 
                    <tbody> 
                     <tr> 
                      <td style="padding:0 5px 0 0"><a href="https://www.linkedin.com/company/webhotelier/" target="_blank"><img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/linkedin@2x.png" width="32" height="auto" alt="LinkedIn" title="LinkedIn" style="display:block;height:auto;border:0"></a></td> 
                      <td style="padding:0 5px 0 0"><a href="https://www.facebook.com/webhotelier" target="_blank"><img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/facebook.png" width="32" height="auto" alt="Facebook" title="Facebook" style="display:block;height:auto;border:0"></a></td> 
                      <td style="padding:0 5px 0 0"> <a href="https://www.instagram.com/webhotelier_primalres/" target="_blank"><img src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/instagram@2x.png" width="32" height="auto" alt="Instagram" title="Instagram" style="display:block;height:auto;border:0"></a></td> 
                     </tr> 
                    </tbody> 
                   </table> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table> 
              <table class="text_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div style="font-family:Verdana,sans-serif"> 
                   <div class="" style="font-size:12px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:18px;color:#d0d0d0;line-height:1.5"> 
                    <p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:18px"> <span style="word-break: break-word; font-size: 12px; color: #d0d0d0;"><a href="https://www.webhotelier.net/" target="_blank" clicktracking="on" style="text-decoration:underline;color:#d0d0d0;" rel="noopener"><span style="word-break: break-word;">webhotelier | primalres</span></a>&nbsp; &nbsp;© All rights reserved 2026</span></p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table> 
      <table class="row row-20" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"> 
       <tbody> 
        <tr> 
         <td> 
          <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;color:#000;width:625px;margin:0 auto" width="625"> 
           <tbody> 
            <tr> 
             <td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:10px;padding-top:10px;vertical-align:top"> 
              <table class="text_block block-1" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"> 
               <tbody> 
                <tr> 
                 <td class="pad"> 
                  <div style="font-family:sans-serif"> 
                   <div class="" style="font-size:10px;font-family:Verdana,Geneva,sans-serif;mso-line-height-alt:12px;color:#555;line-height:1.2"> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:12px">Message sent by:<br><br>Revplus Hellas S.A.<br>Leoforos Rodou-Lindou 5km, 85100 Rhodes,<br> Greece.</p> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:12px">&nbsp;</p> 
                    <p style="margin:0;text-align:center;mso-line-height-alt:12px"><br>Don't want to receive emails from us? Manage your email preferences <a href="https://primalres-team.myfreshworks.com/crm/marketer/mas/api/v1/subscription-preferences?fm_digest=317E3A4DCB8D137600705EBE74A05DA3BCB51EC665E7DB2F143CBD52E4F05AF77A322942FB978298970354C8EFFC63E7251415027D2F2C26FC3264341C94A68D942A166865892B6C6DC9392EF2B3B4273E947BAF71774ACA8E2F3DA65A0EDA08963935358B2BDDD8BAC3281185F41DF35A305BFC59463798EF236D3E0C933151D014E161119A06886E055B56533DC747" target="_blank" rel="noopener" style="text-decoration: underline; color: #0000FF;" clicktracking="on">here</a>.</p> 
                   </div> 
                  </div></td> 
                </tr> 
               </tbody> 
              </table></td> 
            </tr> 
           </tbody> 
          </table></td> 
        </tr> 
       </tbody> 
      </table></td> 
    </tr> 
   </tbody>
`

export const WebHotelierWelcome3 = React.memo(() => {
	return  <div dangerouslySetInnerHTML={{ __html: html }} />
});